// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from 'react-native-web';
import colors from '../../config/colors';
import fonts from '../../config/fonts';
export const textboxStyles = StyleSheet.create({
  input: {
    backgroundColor: colors.green,
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
    fontSize: 13,
    marginBottom: 16,
    color: colors.white,
    fontFamily: fonts.regular,
  },
});
